/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ActiveInterventionsResponse } from '../models/ActiveInterventionsResponse';
import type { AgentLocationDto } from '../models/AgentLocationDto';
import type { CreateInterventionDto } from '../models/CreateInterventionDto';
import type { DeclareEffractionDto } from '../models/DeclareEffractionDto';
import type { EstimatePriceDto } from '../models/EstimatePriceDto';
import type { InterventionDetailResponse } from '../models/InterventionDetailResponse';
import type { InterventionEventLogItem } from '../models/InterventionEventLogItem';
import type { InterventionListPaginatedResponse } from '../models/InterventionListPaginatedResponse';
import type { InterventionStepResponse } from '../models/InterventionStepResponse';
import type { PriceEstimateResponse } from '../models/PriceEstimateResponse';
import type { RequestSurveillanceDto } from '../models/RequestSurveillanceDto';
import type { UpdateStatusDto } from '../models/UpdateStatusDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class InterventionsService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * Request a new intervention
     * Create a new intervention request for a given location. Fails with 403 if no online agents are available in the area. The sector is auto-resolved based on location coordinates if not specified.
     * @returns InterventionDetailResponse Intervention created successfully.
     * @throws ApiError
     */
    public interventionsControllerCreate({
        requestBody,
    }: {
        requestBody: CreateInterventionDto,
    }): CancelablePromise<InterventionDetailResponse> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/interventions',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error.`,
                401: `Unauthorized.`,
                403: `Forbidden. CLIENT role required, or no agents available in the area.`,
                404: `Location not found.`,
            },
        });
    }
    /**
     * List interventions
     * Returns a paginated list of interventions. Results are filtered by user role: clients see their own, agents see assigned, society owners see their society interventions, admins see all.
     * @returns InterventionListPaginatedResponse Paginated list of interventions with minimal fields.
     * @throws ApiError
     */
    public interventionsControllerFindAll({
        page = 1,
        limit = 20,
        sortBy,
        sortOrder = 'desc',
        status,
        clientId,
        agentId,
        societyId,
        sectorId,
        isArchived,
        createdAfter,
        createdBefore,
        hasOffense,
        date,
        search,
    }: {
        /**
         * Page number
         */
        page?: number,
        /**
         * Items per page (max 200)
         */
        limit?: number,
        /**
         * Field to sort by
         */
        sortBy?: string,
        /**
         * Sort order (asc/desc)
         */
        sortOrder?: 'asc' | 'desc',
        /**
         * Filter by status
         */
        status?: 'REQUESTED' | 'WAITING_FOR_AGENT_ACCEPTATION' | 'ACCEPTED' | 'PAYMENT_IN_PROGRESS' | 'PAYMENT_DONE' | 'PAYMENT_FAILED' | 'PAYMENT_TIMED_OUT' | 'AGENT_MOVING' | 'INSPECTION_IN_PROGRESS' | 'NO_EFFRACTION' | 'EFFRACTION' | 'NO_SURVEILLANCE' | 'SURVEILLANCE_IN_PROGRESS' | 'SURVEILLANCE_DONE' | 'REPORT_IN_PROGRESS' | 'REJECTED' | 'CANCELED' | 'HIDDEN' | 'DONE' | 'PRICE_PROPOSED' | 'PRICE_ACCEPTED' | 'SURVEILLANCE_PAYMENT_IN_PROGRESS' | 'SURVEILLANCE_PAYMENT_DONE' | 'SURVEILLANCE_PAYMENT_FAILED' | 'SURVEILLANCE_PAYMENT_TIMED_OUT',
        /**
         * Filter by client user ID
         */
        clientId?: string,
        /**
         * Filter by agent user ID (ADMIN and SOCIETY_OWNER only)
         */
        agentId?: string,
        /**
         * Filter by society ID
         */
        societyId?: string,
        /**
         * Filter by sector ID (ADMIN and SOCIETY_OWNER only)
         */
        sectorId?: string,
        /**
         * Filter by archived status
         */
        isArchived?: boolean,
        /**
         * Filter interventions created after this date (ISO 8601)
         */
        createdAfter?: string,
        /**
         * Filter interventions created before this date (ISO 8601)
         */
        createdBefore?: string,
        /**
         * Filter by incident/offense status
         */
        hasOffense?: boolean,
        /**
         * Filter interventions created on a specific date (YYYY-MM-DD or DD/MM/YYYY)
         */
        date?: string,
        /**
         * Search across location address, location label, agent name, and society name
         */
        search?: string,
    }): CancelablePromise<InterventionListPaginatedResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/interventions',
            query: {
                'page': page,
                'limit': limit,
                'sortBy': sortBy,
                'sortOrder': sortOrder,
                'status': status,
                'clientId': clientId,
                'agentId': agentId,
                'societyId': societyId,
                'sectorId': sectorId,
                'isArchived': isArchived,
                'createdAfter': createdAfter,
                'createdBefore': createdBefore,
                'hasOffense': hasOffense,
                'date': date,
                'search': search,
            },
            errors: {
                401: `Unauthorized.`,
            },
        });
    }
    /**
     * Get active interventions
     * Returns all non-archived, non-terminal interventions for the current user. Used by agents, clients, and society owners to see current activity.
     * @returns ActiveInterventionsResponse Active interventions.
     * @throws ApiError
     */
    public interventionsControllerGetActive(): CancelablePromise<ActiveInterventionsResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/interventions/active',
            errors: {
                401: `Unauthorized.`,
            },
        });
    }
    /**
     * Get intervention event log
     * Returns the chronological event history for an intervention since a given timestamp. Used by clients to catch up on missed gRPC events after reconnection.
     * @returns InterventionEventLogItem Event log returned.
     * @throws ApiError
     */
    public interventionsControllerGetEventLog({
        id,
        since,
    }: {
        /**
         * Intervention unique identifier
         */
        id: string,
        /**
         * ISO 8601 timestamp to fetch events after
         */
        since?: string,
    }): CancelablePromise<Array<InterventionEventLogItem>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/interventions/{id}/events',
            path: {
                'id': id,
            },
            query: {
                'since': since,
            },
            errors: {
                401: `Unauthorized.`,
                403: `Forbidden. Not a participant.`,
                404: `Intervention not found.`,
            },
        });
    }
    /**
     * Get intervention detail
     * Returns full intervention details including client, agent, society, sector, and location data. Only participants or admins can access.
     * @returns InterventionDetailResponse Intervention found.
     * @throws ApiError
     */
    public interventionsControllerFindOne({
        id,
    }: {
        /**
         * Intervention unique identifier
         */
        id: string,
    }): CancelablePromise<InterventionDetailResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/interventions/{id}',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized.`,
                403: `Forbidden. Not a participant.`,
                404: `Intervention not found.`,
            },
        });
    }
    /**
     * Get invoice PDF signed URL for an intervention
     * Returns a time-limited Firebase Storage signed URL (60 min) for downloading the invoice PDF associated with the intervention. Only participants or admins can access.
     * @returns any Signed URL for invoice PDF download.
     * @throws ApiError
     */
    public interventionsControllerGetInvoicePdfUrl({
        id,
    }: {
        /**
         * Intervention unique identifier
         */
        id: string,
    }): CancelablePromise<{
        url?: string;
    }> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/interventions/{id}/invoice-pdf-url',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized.`,
                403: `Forbidden. Not a participant.`,
                404: `Intervention or invoice not found, or PDF not yet generated.`,
            },
        });
    }
    /**
     * Get current intervention step
     * Returns the current step info including valid next statuses. Used by client/agent UI to display progress.
     * @returns InterventionStepResponse Step information.
     * @throws ApiError
     */
    public interventionsControllerGetStep({
        id,
    }: {
        /**
         * Intervention unique identifier
         */
        id: string,
    }): CancelablePromise<InterventionStepResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/interventions/{id}/step',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized.`,
                404: `Intervention not found.`,
            },
        });
    }
    /**
     * Get intervention report PDF signed URL
     * Returns a time-limited signed URL (60 min) for downloading the intervention report PDF. The report must have been generated first (available after intervention completion). Only participants or admins can access.
     * @returns any Signed URL for report PDF download.
     * @throws ApiError
     */
    public interventionsControllerGetReportPdfUrl({
        id,
    }: {
        /**
         * Intervention unique identifier
         */
        id: string,
    }): CancelablePromise<{
        url?: string;
    }> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/interventions/{id}/report-pdf-url',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized.`,
                403: `Forbidden. Not a participant.`,
                404: `Intervention or report not found, or PDF not yet generated.`,
            },
        });
    }
    /**
     * Get intervention photos
     * Returns all photos attached to the intervention report. Photos are uploaded by the agent during or after the intervention. Returns an empty array if no report exists yet.
     * @returns any List of intervention photos.
     * @throws ApiError
     */
    public interventionsControllerGetPhotos({
        id,
    }: {
        /**
         * Intervention unique identifier
         */
        id: string,
    }): CancelablePromise<{
        reportId?: string | null;
        photos?: Array<{
            id?: string;
            url?: string;
            caption?: string | null;
            createdAt?: string;
        }>;
    }> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/interventions/{id}/photos',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized.`,
                403: `Forbidden. Not a participant.`,
                404: `Intervention not found.`,
            },
        });
    }
    /**
     * Get location photos for an intervention
     * Returns the photo gallery of the intervention location with time-limited signed URLs (60 min expiry). These are photos the client uploaded of their property (building exterior, access points, alarm panels, etc.). Useful for agents to review the site before or during an intervention. Only intervention participants (client, assigned agent, society owner) or admins can access.
     * @returns any Location photos with signed URLs.
     * @throws ApiError
     */
    public interventionsControllerGetLocationPhotos({
        id,
    }: {
        /**
         * Intervention unique identifier
         */
        id: string,
    }): CancelablePromise<{
        locationId?: string | null;
        locationLabel?: string | null;
        photos?: Array<{
            id?: string;
            url?: string;
            label?: string | null;
            createdAt?: string;
            expiresAt?: string | null;
        }>;
    }> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/interventions/{id}/location-photos',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized.`,
                403: `Forbidden. Not a participant.`,
                404: `Intervention not found.`,
            },
        });
    }
    /**
     * Advance intervention status
     * Transition the intervention to a new status. The transition must be valid according to the state machine. Role-based permissions apply.
     * @returns InterventionDetailResponse Status updated successfully.
     * @throws ApiError
     */
    public interventionsControllerUpdateStatus({
        id,
        requestBody,
    }: {
        /**
         * Intervention unique identifier
         */
        id: string,
        requestBody: UpdateStatusDto,
    }): CancelablePromise<InterventionDetailResponse> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/api/interventions/{id}/status',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Invalid transition.`,
                401: `Unauthorized.`,
                403: `Forbidden.`,
                404: `Intervention not found.`,
            },
        });
    }
    /**
     * Agent accepts intervention
     * An online agent accepts a waiting intervention (1-click action, no pricing input). The agent is assigned, the society/sector are linked, and the system automatically derives the price from the sector fixed rates (interventionPrice, extraTimePrice, extraDistancePrice), injecting it into pricingData and transitioning to PRICE_PROPOSED. The client must then accept or reject the price. Fails with 400 if the sector or its prices cannot be resolved.
     * @returns InterventionDetailResponse Intervention accepted.
     * @throws ApiError
     */
    public interventionsControllerAccept({
        id,
    }: {
        /**
         * Intervention unique identifier
         */
        id: string,
    }): CancelablePromise<InterventionDetailResponse> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/interventions/{id}/accept',
            path: {
                'id': id,
            },
            errors: {
                400: `Invalid state, agent offline, or sector pricing unavailable.`,
                401: `Unauthorized.`,
                403: `Forbidden. AGENT role required.`,
                404: `Intervention not found.`,
            },
        });
    }
    /**
     * Agent rejects intervention
     * An agent rejects a waiting intervention. The agent is immediately set offline (isOnline = false) and receives a push notification informing them. The system then attempts to find another nearby online agent for reassignment. If found, the intervention goes back to WAITING_FOR_AGENT_ACCEPTATION with a new timer.
     * @returns InterventionDetailResponse Intervention rejected. Agent set offline and notified via push. Reassignment attempted.
     * @throws ApiError
     */
    public interventionsControllerReject({
        id,
    }: {
        /**
         * Intervention unique identifier
         */
        id: string,
    }): CancelablePromise<InterventionDetailResponse> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/interventions/{id}/reject',
            path: {
                'id': id,
            },
            errors: {
                400: `Invalid state.`,
                401: `Unauthorized.`,
                403: `Forbidden. AGENT role required.`,
                404: `Intervention not found.`,
            },
        });
    }
    /**
     * Client accepts proposed price
     * The client accepts the system-proposed price (derived from the sector fixed prices). Transitions from PRICE_PROPOSED to PRICE_ACCEPTED. Payment can then be initiated.
     * @returns InterventionDetailResponse Price accepted.
     * @throws ApiError
     */
    public interventionsControllerAcceptPrice({
        id,
    }: {
        /**
         * Intervention unique identifier
         */
        id: string,
    }): CancelablePromise<InterventionDetailResponse> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/interventions/{id}/accept-price',
            path: {
                'id': id,
            },
            errors: {
                400: `Not in PRICE_PROPOSED state.`,
                401: `Unauthorized.`,
                403: `Forbidden. CLIENT role required.`,
                404: `Intervention not found.`,
            },
        });
    }
    /**
     * Client rejects proposed price
     * The client rejects the system-proposed price. Transitions from PRICE_PROPOSED to CANCELED. The agent is notified.
     * @returns InterventionDetailResponse Price rejected, intervention canceled.
     * @throws ApiError
     */
    public interventionsControllerRejectPrice({
        id,
    }: {
        /**
         * Intervention unique identifier
         */
        id: string,
    }): CancelablePromise<InterventionDetailResponse> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/interventions/{id}/reject-price',
            path: {
                'id': id,
            },
            errors: {
                400: `Not in PRICE_PROPOSED state.`,
                401: `Unauthorized.`,
                403: `Forbidden. CLIENT role required.`,
                404: `Intervention not found.`,
            },
        });
    }
    /**
     * Client cancels intervention
     * The client cancels an intervention. Only cancellable before the agent starts moving (AGENT_MOVING or later). No refund is provided once the agent has started moving.
     * @returns InterventionDetailResponse Intervention canceled.
     * @throws ApiError
     */
    public interventionsControllerCancel({
        id,
    }: {
        /**
         * Intervention unique identifier
         */
        id: string,
    }): CancelablePromise<InterventionDetailResponse> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/interventions/{id}/cancel',
            path: {
                'id': id,
            },
            errors: {
                400: `Cannot cancel at this stage.`,
                401: `Unauthorized.`,
                403: `Forbidden. Cannot cancel after agent started moving. No refund.`,
                404: `Intervention not found.`,
            },
        });
    }
    /**
     * Update agent GPS position
     * The assigned agent updates their real-time GPS position during AGENT_MOVING phase.
     * @returns InterventionDetailResponse Position updated.
     * @throws ApiError
     */
    public interventionsControllerUpdatePosition({
        id,
        requestBody,
    }: {
        /**
         * Intervention unique identifier
         */
        id: string,
        requestBody: AgentLocationDto,
    }): CancelablePromise<InterventionDetailResponse> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/api/interventions/{id}/position',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Not in AGENT_MOVING state.`,
                401: `Unauthorized.`,
                403: `Forbidden. Not the assigned agent.`,
                404: `Intervention not found.`,
            },
        });
    }
    /**
     * Agent declares start moving
     * The assigned agent declares they are starting to move towards the intervention location. Transitions from PAYMENT_DONE to AGENT_MOVING. The agent must wait for the client payment to be validated before declaring movement.
     * @returns InterventionDetailResponse Agent movement started.
     * @throws ApiError
     */
    public interventionsControllerStartMoving({
        id,
    }: {
        /**
         * Intervention unique identifier
         */
        id: string,
    }): CancelablePromise<InterventionDetailResponse> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/interventions/{id}/start-moving',
            path: {
                'id': id,
            },
            errors: {
                400: `Not in PAYMENT_DONE state.`,
                401: `Unauthorized.`,
                403: `Forbidden. Not the assigned agent.`,
                404: `Intervention not found.`,
            },
        });
    }
    /**
     * Agent declares arrival
     * The assigned agent declares they have arrived at the intervention location. The system verifies the agent GPS position is within proximity of the location. Transitions from AGENT_MOVING to INSPECTION_IN_PROGRESS.
     * @returns InterventionDetailResponse Arrival confirmed, inspection started.
     * @throws ApiError
     */
    public interventionsControllerArrive({
        id,
    }: {
        /**
         * Intervention unique identifier
         */
        id: string,
    }): CancelablePromise<InterventionDetailResponse> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/interventions/{id}/arrive',
            path: {
                'id': id,
            },
            errors: {
                400: `Not in AGENT_MOVING state or agent not at location.`,
                401: `Unauthorized.`,
                403: `Forbidden. Not the assigned agent.`,
                404: `Intervention not found.`,
            },
        });
    }
    /**
     * Declare effraction or no-effraction
     * The agent declares whether an effraction (break-in) was detected during inspection. Transitions to EFFRACTION or REPORT_IN_PROGRESS.
     * @returns InterventionDetailResponse Effraction declared.
     * @throws ApiError
     */
    public interventionsControllerDeclareEffraction({
        id,
        requestBody,
    }: {
        /**
         * Intervention unique identifier
         */
        id: string,
        requestBody: DeclareEffractionDto,
    }): CancelablePromise<InterventionDetailResponse> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/interventions/{id}/declare-effraction',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Not in INSPECTION_IN_PROGRESS state.`,
                401: `Unauthorized.`,
                403: `Forbidden. AGENT role required.`,
                404: `Intervention not found.`,
            },
        });
    }
    /**
     * Client requests surveillance after effraction
     * The client requests surveillance after an effraction was declared, selecting a number of hours. Surveillance is NOT included in the first intervention payment: this transitions from EFFRACTION to SURVEILLANCE_PAYMENT_IN_PROGRESS, freezes the surveillance amount (extra time only: extraTimePrice × durationHours + TVA + wisecure fee) and starts the surveillance-payment countdown. The client must then pay via the Stripe payment-intent endpoint before surveillance can begin.
     * @returns InterventionDetailResponse Surveillance requested, awaiting payment.
     * @throws ApiError
     */
    public interventionsControllerRequestSurveillance({
        id,
        requestBody,
    }: {
        /**
         * Intervention unique identifier
         */
        id: string,
        requestBody: RequestSurveillanceDto,
    }): CancelablePromise<InterventionDetailResponse> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/interventions/{id}/request-surveillance',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Not in EFFRACTION state.`,
                401: `Unauthorized.`,
                403: `Forbidden. CLIENT role required.`,
                404: `Intervention not found.`,
            },
        });
    }
    /**
     * Client declines/abandons surveillance
     * The client declines surveillance, or abandons it while its payment is pending/failed/timed out. Transitions to NO_SURVEILLANCE so the intervention still proceeds to report generation (the agent is freed and a report is produced). Usable from EFFRACTION, SURVEILLANCE_PAYMENT_IN_PROGRESS, SURVEILLANCE_PAYMENT_FAILED and SURVEILLANCE_PAYMENT_TIMED_OUT.
     * @returns InterventionDetailResponse Surveillance declined/abandoned.
     * @throws ApiError
     */
    public interventionsControllerDeclineSurveillance({
        id,
    }: {
        /**
         * Intervention unique identifier
         */
        id: string,
    }): CancelablePromise<InterventionDetailResponse> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/interventions/{id}/decline-surveillance',
            path: {
                'id': id,
            },
            errors: {
                400: `Not in a surveillance-declinable state.`,
                401: `Unauthorized.`,
                403: `Forbidden. CLIENT role required.`,
                404: `Intervention not found.`,
            },
        });
    }
    /**
     * Retry a failed surveillance payment
     * The client retries the surveillance payment after a previous failure. Transitions from SURVEILLANCE_PAYMENT_FAILED back to SURVEILLANCE_PAYMENT_IN_PROGRESS and restarts the surveillance-payment countdown timer. The client must then pay via the Stripe payment-intent endpoint.
     * @returns InterventionDetailResponse Surveillance payment retry initiated.
     * @throws ApiError
     */
    public interventionsControllerRetrySurveillancePayment({
        id,
    }: {
        /**
         * Intervention unique identifier
         */
        id: string,
    }): CancelablePromise<InterventionDetailResponse> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/interventions/{id}/retry-surveillance-payment',
            path: {
                'id': id,
            },
            errors: {
                400: `Not in SURVEILLANCE_PAYMENT_FAILED state.`,
                401: `Unauthorized.`,
                403: `Forbidden. CLIENT role required.`,
                404: `Intervention not found.`,
            },
        });
    }
    /**
     * End surveillance
     * The assigned agent declares surveillance complete. Transitions from SURVEILLANCE_IN_PROGRESS to SURVEILLANCE_DONE.
     * @returns InterventionDetailResponse Surveillance completed.
     * @throws ApiError
     */
    public interventionsControllerSurveillanceDone({
        id,
    }: {
        /**
         * Intervention unique identifier
         */
        id: string,
    }): CancelablePromise<InterventionDetailResponse> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/interventions/{id}/surveillance-done',
            path: {
                'id': id,
            },
            errors: {
                400: `Surveillance is not in progress.`,
                401: `Unauthorized.`,
                403: `Forbidden. AGENT role required.`,
                404: `Intervention not found.`,
            },
        });
    }
    /**
     * Initiate payment for intervention
     * The client initiates payment after accepting the system-proposed price. Transitions from PRICE_ACCEPTED to PAYMENT_IN_PROGRESS and starts a payment countdown timer.
     * @returns InterventionDetailResponse Payment initiated.
     * @throws ApiError
     */
    public interventionsControllerInitiatePayment({
        id,
    }: {
        /**
         * Intervention unique identifier
         */
        id: string,
    }): CancelablePromise<InterventionDetailResponse> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/interventions/{id}/initiate-payment',
            path: {
                'id': id,
            },
            errors: {
                400: `Intervention not in PRICE_ACCEPTED state.`,
                401: `Unauthorized.`,
                403: `Forbidden. CLIENT role required.`,
                404: `Intervention not found.`,
            },
        });
    }
    /**
     * Hide a canceled intervention
     * The client hides a canceled intervention from their active list. Transitions from CANCELED to HIDDEN.
     * @returns InterventionDetailResponse Intervention hidden.
     * @throws ApiError
     */
    public interventionsControllerHide({
        id,
    }: {
        /**
         * Intervention unique identifier
         */
        id: string,
    }): CancelablePromise<InterventionDetailResponse> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/interventions/{id}/hide',
            path: {
                'id': id,
            },
            errors: {
                400: `Not in CANCELED state.`,
                401: `Unauthorized.`,
                403: `Forbidden. CLIENT role required.`,
                404: `Intervention not found.`,
            },
        });
    }
    /**
     * Retry a failed payment
     * The client retries payment after a previous failure. Transitions from PAYMENT_FAILED to PAYMENT_IN_PROGRESS and restarts the payment countdown timer.
     * @returns InterventionDetailResponse Payment retry initiated.
     * @throws ApiError
     */
    public interventionsControllerRetryPayment({
        id,
    }: {
        /**
         * Intervention unique identifier
         */
        id: string,
    }): CancelablePromise<InterventionDetailResponse> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/interventions/{id}/retry-payment',
            path: {
                'id': id,
            },
            errors: {
                400: `Not in PAYMENT_FAILED state.`,
                401: `Unauthorized.`,
                403: `Forbidden. CLIENT role required.`,
                404: `Intervention not found.`,
            },
        });
    }
    /**
     * Estimate intervention price
     * Returns an estimated price for an intervention at the given coordinates. Considers the nearest sector pricing and calculates agent travel distance using Google Directions when the agent is outside the sector range.
     * @returns PriceEstimateResponse Price estimate returned successfully.
     * @throws ApiError
     */
    public interventionsControllerEstimatePrice({
        requestBody,
    }: {
        requestBody: EstimatePriceDto,
    }): CancelablePromise<PriceEstimateResponse> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/interventions/estimate-price',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error.`,
                401: `Unauthorized.`,
                403: `Forbidden. CLIENT role required.`,
                404: `No sector found for this location, or no agents available in the area.`,
            },
        });
    }
}
